import React from "react";
import { Star } from "lucide-react";

const GOLD = "#E2A712";

export const StarRow = ({ value = 0, size = "w-3.5 h-3.5", dim = "text-black/15" }) => (
    <span className="inline-flex items-center gap-0.5" aria-hidden="true">
        {[1, 2, 3, 4, 5].map((n) => (
            <Star key={n} className={`${size} ${n <= Math.round(value) ? "" : dim}`}
                style={n <= Math.round(value) ? { fill: GOLD, color: GOLD } : undefined} />
        ))}
    </span>
);

/** One rating for the whole site — the product payload carries the blended average. */
export const RatingLine = ({ product, className = "", size, dim, textClass = "text-xs" }) => {
    const value = Number(product?.rating || 0);
    if (!value) return null;
    const count = Number(product?.rating_count || 0);
    return (
        <span className={`inline-flex items-center gap-2 ${className}`}
            data-testid={`product-rating-${product.slug}`}
            aria-label={`Rated ${value.toFixed(1)} out of 5 from ${count} ratings`}>
            <StarRow value={value} size={size} dim={dim} />
            <span className={textClass}>
                {value.toFixed(1)}{count ? ` (${count})` : ""}
            </span>
        </span>
    );
};

export default RatingLine;
